export default __webpack_public_path__ + "static/media/zodiacToto-Rat.cca67707.png";